<template>
  <div class="supplier-orders-list-container">
    <!-- 顶部标题栏 -->
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>订单管理</span>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-input
        v-model="searchParams.orderId"
        placeholder="订单编号"
        clearable
        class="search-input"
      ></el-input>
      
      <el-input
        v-model="searchParams.orderTitle"
        placeholder="订单标题"
        clearable
        class="search-input"
        prefix-icon="el-icon-search"
      ></el-input>
      
      <el-select
        v-model="searchParams.status"
        placeholder="订单状态"
        clearable
        class="search-input"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      
      <el-select
        v-model="searchParams.orderType"
        placeholder="订单类型"
        clearable
        class="search-input"
      >
        <el-option
          v-for="item in orderTypeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
    </div>
    
    <!-- 订单列表 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      :row-class-name="getRowClassName"
    >
      <el-table-column
        prop="orderId"
        label="订单编号"
        width="180"
      ></el-table-column>
      
      <el-table-column
        label="订单标题"
        prop="orderTitle"
        min-width="200"
      >
        <template slot-scope="scope">
          {{ scope.row.orderTitle || '无标题' }}
        </template>
      </el-table-column>
      
      <el-table-column
        label="订单类型"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag 
            :type="getOrderTypeTagType(scope.row.orderType)"
            size="small"
          >
            {{ getOrderTypeText(scope.row.orderType) }}
          </el-tag>
        </template>
      </el-table-column>
      
        <!-- 合同信息列 -->
        <el-table-column
          label="合同信息"
          min-width="180"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.contractDetails && scope.row.contractDetails.length > 0">
              {{ scope.row.contractDetails.map(contract => contract.contractName || '--').join('，') }}
            </div>
            <div v-else-if="scope.row.contractName">
              {{ scope.row.contractName }}
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
      
      <!-- 添加订单所有者类型列 -->
      <el-table-column
        label="订单角色"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="isCreatedByCurrentUser(scope.row)" type="success" size="small">我创建的</el-tag>
          <el-tag v-else-if="isSuppliedToCurrentUser(scope.row)" type="warning" size="small">我供应的</el-tag>
          <el-tag v-else type="info" size="small">其他</el-tag>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="productsTotal"
        label="产品总数"
        width="100"
        align="center"
      ></el-table-column>
      
      <el-table-column
        prop="priceTotal"
        label="总价"
        width="120"
        align="center"
      ></el-table-column>
      
      <el-table-column
        prop="status"
        label="订单状态"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">
            {{ scope.row.status | formatStatus }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.createTime | formatDate }}
        </template>
      </el-table-column>
      
      <el-table-column
        label="操作"
        width="220"
        align="center"
      >
        <template slot-scope="scope">
          <!-- 待接受状态 -->
          <div v-if="scope.row.status === '待接受'">
            <el-button
              type="primary"
              size="mini"
              @click="viewOrder(scope.row.id)"
            >查看</el-button>
            <el-button
              v-permission="'orders:customer-orders-list:delete'"
              type="danger"
              size="mini"
              @click="deleteOrder(scope.row.id)"
            >删除</el-button>
          </div>
          
          <!-- 已分发状态 -->
          <div v-else-if="scope.row.status === '已分发'">
            <el-button
              type="primary"
              size="mini"
              @click="viewOrder(scope.row.id)"
            >查看</el-button>
            <!-- 暂时隐藏取消分发按钮，但保留代码
            <el-button
              v-if="canCancelDistribution(scope.row.id)"
              type="danger"
              size="mini"
              @click="cancelDistribution(scope.row.id)"
            >取消分发</el-button>
            <el-tooltip
            v-else
              effect="dark"
              content="只有当所有子订单都是'待接受'状态时才能取消分发"
              placement="top"
            >
              <el-button
                type="danger"
                size="mini"
                disabled
              >取消分发</el-button>
            </el-tooltip>
            -->
          </div>
          
          <!-- 执行中状态且为集采类型 -->
          <div v-else-if="scope.row.status === '执行中' && scope.row.order_type === '集采'">
            <el-button
              type="primary"
              size="mini"
              @click="viewOrder(scope.row.id)"
            >查看</el-button>
            <!-- 暂时隐藏分发按钮，但保留代码 
            <el-button
              v-if="!hasChildOrders(scope.row.id)"
              type="warning"
              size="mini"
              @click="distributeOrder(scope.row.id)"
            >一键分发</el-button>
            -->
          </div>
          
          <!-- 进行中状态 (EXECUTING) -->
          <div v-else-if="scope.row.status === 'EXECUTING'">
            <el-button
              type="primary"
              size="mini"
              @click="viewOrder(scope.row.id)"
            >查看</el-button>
            <el-button
              v-if="canRevokeOrder(scope.row)"
              type="danger"
              size="mini"
              @click="revokeOrder(scope.row.id)"
            >撤销</el-button>
          </div>
          
          <!-- 其他状态 -->
          <div v-else>
            <el-button
              type="primary"
              size="mini"
              @click="viewOrder(scope.row.id)"
            >查看</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
    
  </div>
</template>

<script>
import { query_sales_orders, delete_order, update_order_status } from '@/api/modules/orders.js';

export default {
  name: 'SupplierOrdersList',
  filters: {
    // 日期格式化过滤器
    formatDate(dateString) {
      if (!dateString) return '';
      
      try {
        const date = new Date(dateString);
        // 检查日期是否有效
        if (isNaN(date.getTime())) return dateString;
        
        // 格式化为 YYYY-MM-DD
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        return `${year}-${month}-${day}`;
      } catch (error) {
        console.error('日期格式化错误:', error);
        return dateString;
      }
    },
    // 货币格式化过滤器
    formatCurrency(value) {
      if (!value && value !== 0) return '0.00';
      
      try {
        const num = parseFloat(value);
        if (isNaN(num)) return '0.00';
        
        return num.toFixed(2);
      } catch (error) {
        console.error('货币格式化错误:', error);
        return '0.00';
      }
    },
    // 状态格式化过滤器
    formatStatus(status) {
      const statusMap = {
        'ACTIVE': '待确认',
        'EXECUTING': '进行中',
        'SENDING': '已发货',
        'RECEIVING': '已收货',
        'END': '已结束'
      };
      return statusMap[status] || status;
    }
  },
  data() {
    return {
      searchParams: {
        orderId: '', // 订单编号
        orderTitle: '', // 订单标题，与API对应
        status: '',
        orderType: '', // 订单类型
      },
      statusOptions: [
        { value: 'ACTIVE', label: '待确认' },
        { value: 'EXECUTING', label: '进行中' },
        { value: 'SENDING', label: '已发货' },
        { value: 'RECEIVING', label: '已收货' },
        { value: 'END', label: '已结束' }
      ],
      orderTypeOptions: [
        { value: '01', label: '正常订单' },
        { value: '02', label: '退货订单' }
      ],
      loading: false,
      orderList: [], // 主订单列表
      tableData: [], // 表格显示数据（包含主订单和展开的子订单）
      pagination: {
        page: 1, // 修改为与API参数对应
        pageSize: 10,
        total: 0
      },
      currentUnitId: null,
      currentUserId: null,
    };
  },
  created() {
    // 先获取用户信息，再获取订单列表
    this.getCurrentUnitId();
    // 不需要在此调用getOrderList，因为getCurrentUnitId中会调用
  },
  methods: {
    // 判断是否可以撤销订单（当前用户是该订单的供应商）
    canRevokeOrder(order) {
      const supplierId = order.supplierId || order.supplier_id || order.supplierUnitId;
      return supplierId === this.currentUnitId;
    },

    // 撤销订单（从进行中改回待确认）
    revokeOrder(orderId) {
      this.$confirm('确定要撤销该订单吗？撤销后订单状态将变为待确认。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        update_order_status(orderId, 'ACTIVE').then(() => {
          this.$message.success('订单已撤销');
          this.getOrderList();
        }).catch(error => {
          console.error('撤销订单失败:', error);
          this.$message.error('撤销订单失败');
        });
      }).catch(() => {});
    },

    // 获取当前用户的单位ID
    getCurrentUnitId() {
      try {
        // 添加防御性检查，避免访问不存在的属性
        const store = this.$store || {};
        const state = store.state || {};
        
        // 打印store结构，帮助调试
// 尝试从不同可能的路径获取用户信息
        let userInfo = null;
        
        if (state.user && state.user.userInfo) {
          // 如果是 state.user.userInfo 的结构
          userInfo = state.user.userInfo;
} else if (state.userInfo) {
          // 如果是 state.userInfo 的结构
          userInfo = state.userInfo;
} else if (state.auth && state.auth.userInfo) {
          // 如果是 state.auth.userInfo 的结构
          userInfo = state.auth.userInfo;
}
        
        // 如果找不到，可以考虑从localStorage获取
        if (!userInfo || !userInfo.unitId) {
          const localUserInfo = localStorage.getItem('userInfo');
          if (localUserInfo) {
            try {
              userInfo = JSON.parse(localUserInfo);
} catch (e) {
              console.error('解析localStorage中的userInfo失败:', e);
            }
          }
        }
        
// 保存用户信息到调试区域显示
        this.userUnitInfo = userInfo;
        
        if (userInfo && userInfo.unitId) {
          this.currentUnitId = userInfo.unitId;
} else {
          console.warn('未能获取unitId，将使用默认值1进行测试');
          // 使用默认值便于测试
          this.currentUnitId = 1;
        }
        
        // 同时获取当前用户ID
        if (userInfo && userInfo.id) {
          this.currentUserId = userInfo.id;
} else if (userInfo && userInfo.userId) {
          this.currentUserId = userInfo.userId;
} else {
          console.warn('未能获取用户ID，将使用默认值1进行测试');
          this.currentUserId = 1;
        }
      } catch (err) {
        console.error('获取用户unitId出错:', err);
        console.warn('发生错误，将使用默认值1进行测试');
        // 出错时使用默认值便于测试
        this.currentUnitId = 1;
      }
      
      // 获取完单位ID后加载订单列表
      this.getOrderList();
    },
    
    // 获取订单列表
    getOrderList() {
      this.loading = true;
      
      // 构建查询参数（新的销售订单API格式）
      const params = {
        orderId: this.searchParams.orderId || undefined,
        orderTitle: this.searchParams.orderTitle || undefined, // 使用订单标题搜索
        status: this.searchParams.status || undefined,
        orderType: this.searchParams.orderType || undefined, // 订单类型过滤
        page: this.pagination.page - 1, // 后端页码从0开始
        size: this.pagination.pageSize
      };
      
      // 移除undefined的值
      Object.keys(params).forEach(key => {
        if (params[key] === undefined) {
          delete params[key];
        }
      });
      
      // 详细调试输出
// 调用API获取订单数据
      query_sales_orders(params)
        .then(response => {
if (response.data && response.data.success) {
            // 解析新API返回的数据结构
            const responseData = response.data.data;
            
            // 新API返回格式：{ content: [], totalElements: number, totalPages: number, ... }
            let orderList = [];
            let total = 0;
            
            if (responseData.content && Array.isArray(responseData.content)) {
              orderList = responseData.content;
              total = responseData.totalElements || 0;
} else if (responseData.data && Array.isArray(responseData.data)) {
              orderList = responseData.data;
              total = responseData.total || responseData.count || 0;
} else if (responseData.records && Array.isArray(responseData.records)) {
              orderList = responseData.records;
              total = responseData.total || responseData.count || 0;
} else if (Array.isArray(responseData)) {
              orderList = responseData;
              total = responseData.length;
} else {
              console.warn('未找到有效的订单数据数组');
            }
            
            // 为每个订单添加默认的orderType（如果不存在）
            const processedOrderList = orderList.map(order => ({
              ...order,
              orderType: order.orderType || '01' // 默认为正常订单
            }));
            
            // 设置订单列表和表格数据
            this.orderList = processedOrderList;
            this.tableData = processedOrderList;
            
            // 设置总记录数
            this.pagination.total = total;
            
} else {
            this.$message.error(response.data?.message || '获取订单列表失败');
            console.error('获取订单列表失败:', response.data?.message);
          }
          this.loading = false;
        })
        .catch(error => {
          console.error('==========请求错误==========');
          console.error('获取订单列表失败:', error);
          console.error('请求配置:', error.config);
          console.error('响应状态:', error.response?.status);
          console.error('响应数据:', error.response?.data);
          this.$message.error('获取订单列表失败: ' + (error.message || '未知错误'));
          this.loading = false;
        });
    },
    
    // 加载两种类型的订单（创建者和供应商）
    loadBothTypesOfOrders() {
      this.loading = true;
      this.orderList = [];
      this.tableData = [];
            
      // 使用新的销售订单API格式构建参数
      const baseParams = {
        orderId: this.searchParams.orderId || undefined,
        orderTitle: this.searchParams.orderTitle || undefined, // 订单标题（模糊查询）
        status: this.searchParams.status || undefined,
        page: this.pagination.page - 1, // 后端页码从0开始
        size: this.pagination.pageSize
      };
            
      // 移除undefined的值
      Object.keys(baseParams).forEach(key => {
        if (baseParams[key] === undefined) {
          delete baseParams[key];
        }
      });
      
// 调用新的销售订单API
      query_sales_orders(baseParams)
        .then(response => {
let salesOrders = [];
          let totalCount = 0;
          
          // 处理销售订单响应
          if (response.data && response.data.success) {
            const salesData = response.data.data;
            salesOrders = this.extractOrdersList(salesData);
            totalCount = salesData.totalElements || salesData.total || salesData.count || 0;
            
            // 设置表格数据
            this.tableData = salesOrders;
            this.orderList = salesOrders;
            
            // 设置总记录数
            this.pagination.total = totalCount;
          }
          
          this.loading = false;
        })
        .catch(error => {
          console.error('获取订单列表失败:', error);
          this.$message.error('获取订单列表失败: ' + (error.message || '未知错误'));
          this.loading = false;
        });
    },
    
    // 合并并去重订单列表
    mergeAndDeduplicateOrders(creatorOrders, supplierOrders) {
      // 合并两个订单列表
      const allOrders = [...creatorOrders, ...supplierOrders];
      
      // 使用Map去重，以订单ID为键
      const uniqueOrdersMap = new Map();
      allOrders.forEach(order => {
        uniqueOrdersMap.set(order.id, order);
      });
      
      // 转换回数组
      const uniqueOrders = Array.from(uniqueOrdersMap.values());
      
      // 设置表格数据
      this.tableData = uniqueOrders;
      this.orderList = uniqueOrders;
      
},
    
    // 从响应中提取订单列表
    extractOrdersList(responseData) {
      if (!responseData) return [];
      
      let orderList = [];
      // 优先检查新的销售订单API格式（content数组）
      if (responseData.content && Array.isArray(responseData.content)) {
        orderList = responseData.content;
} else if (responseData.data && Array.isArray(responseData.data)) {
        orderList = responseData.data;
} else if (responseData.records && Array.isArray(responseData.records)) {
        orderList = responseData.records;
} else if (Array.isArray(responseData)) {
        orderList = responseData;
}
      
      return orderList;
    },
    
    // 处理订单API响应
    handleOrdersResponse(response) {
if (response.data && response.data.success) {
        // 解析返回的数据结构，修复数据结构不匹配问题
        const responseData = response.data.data;
      
        // 提取订单列表
        const orderList = this.extractOrdersList(responseData);
      
        // 直接设置表格数据，不需要处理子订单
        this.tableData = orderList;
        this.orderList = orderList;
        
        // 获取总记录数（支持新的销售订单API格式）
        this.pagination.total = responseData.totalElements || responseData.total || responseData.count || 0;
        
} else {
        this.$message.error(response.data?.message || '获取订单列表失败');
        console.error('获取订单列表失败:', response.data?.message);
      }
      this.loading = false;
    },
    
    // 搜索
    handleSearch() {
      // 重置页码
      this.pagination.page = 1;
      // 重新获取订单列表
      this.getOrderList();
    },
    
    // 页码改变
    handleCurrentChange(currentPage) {
      this.pagination.page = currentPage;
      this.getOrderList();
    },
    
    // 每页条数改变
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.page = 1;
      this.getOrderList();
    },
    
    // 查看订单详情
    viewOrder(id) {
      this.$router.push({
        path: `/orders/customer-order-detail/${id}`
      });
    },
    
    // 编辑订单
    editOrder(id) {
      // 销售订单暂时不支持编辑，跳转到查看页面
      this.viewOrder(id);
    },
    
    // 删除订单
    deleteOrder(id) {
      this.$confirm('确认删除该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        // 调用删除订单API
        delete_order(id)
          .then(response => {
            if (response.data && response.data.success) {
              this.$message.success('订单已删除');
              this.getOrderList(); // 刷新列表
            } else {
              this.$message.error(response.data?.message || '删除订单失败');
            }
            this.loading = false;
          })
          .catch(error => {
            console.error('删除订单失败:', error);
            this.$message.error('删除订单失败: ' + (error.message || '未知错误'));
            this.loading = false;
          });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    
    // 一键分发订单
    distributeOrder(id) {
      // 跳转到订单分发页面
      this.$router.push({
        path: `/orders/distribute/${id}`,
        query: { 
          from: 'orders-list'
        }
      });
    },
    
    // 判断订单是否为当前用户创建
    isCurrentUserOrder(order) {
      // 调试信息
// 检查订单的创建者ID是否与当前用户ID匹配
      const isMatch = order.create_id === this.currentUserId || 
                     order.creator_id === this.currentUserId ||
                     order.createId === this.currentUserId ||
                     order.creatorId === this.currentUserId;
      
return isMatch;
    },
    
    // 获取状态标签类型
    getStatusType(status) {
      switch (status) {
        case 'ACTIVE':
          return 'warning';
        case 'EXECUTING':
          return 'success';
        case 'SENDING':
          return 'primary';
        case 'RECEIVING':
          return 'info';
        case 'END':
          return 'success';
        default:
          return 'info';
      }
    },
    
    
    
    // 判断行样式
    getRowClassName({ row }) {
      if (this.isCreatedByCurrentUser(row)) {
        return 'creator-row'; // 我创建的订单行样式
      } else if (this.isSuppliedToCurrentUser(row)) {
        return 'supplier-row'; // 我供应的订单行样式
      }
      return '';
    },
    
    // 判断是否是当前用户创建的订单
    isCreatedByCurrentUser(order) {
      return order.createId === this.currentUnitId || order.create_id === this.currentUnitId;
    },
    
    // 判断是否是当前用户供应的订单
    isSuppliedToCurrentUser(order) {
      return order.supplierId === this.currentUnitId || order.supplier_id === this.currentUnitId;
    },
    
    // 获取订单类型标签类型
    getOrderTypeTagType(orderType) {
      switch (orderType) {
        case '02':
          return 'danger';
        case '01':
        default:
          return 'success';
      }
    },
    
    // 获取订单类型显示文本
    getOrderTypeText(orderType) {
      switch (orderType) {
        case '02':
          return '退货';
        case '01':
        default:
          return '正常';
      }
    },
  }
};
</script>

<style scoped>
.supplier-orders-list-container {
  padding: 20px;
  background-color: #fff;
}
  
  .page-header {
    margin-bottom: 20px;
}
    
    .header-title {
      display: flex;
      align-items: center;
}
      
      .title-mark {
        width: 4px;
        height: 18px;
        background-color: #2c73eb;
        margin-right: 8px;
      }
      
.header-title span {
        font-size: 18px;
        font-weight: 500;
        color: #303133;
  }
  
  .search-area {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
    
    .search-input {
      width: 220px;
      margin-right: 15px;
      margin-bottom: 10px;
    }
    
.search-area .el-button {
      padding: 11px 20px;
      margin-bottom: 10px;
  }
  
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

/* 创建订单相关样式 */
.materials-list {
  margin-top: 10px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 10px;
  background-color: #f9f9f9;
}

.total-info {
  margin-top: 15px;
  text-align: right;
  font-weight: bold;
  padding: 10px;
  border-top: 1px solid #EBEEF5;
}

/* 供应商信息样式 */
.supplier-info {
  margin: 10px 0;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
  line-height: 1.6;
}

.danger-button {
  color: #F56C6C;
}
.danger-button:hover {
  color: #F78989;
}

/* 订单行样式 */
:deep(.creator-row) {
  background-color: #f0f9eb;
}

:deep(.supplier-row) {
  background-color: #fdf6ec;
}
</style>